import actionTypes from '../constants/action-types';

const setBlockTemplates = (blockTemplates) => ({
  type: actionTypes.SET_BLOCK_TEMPLATES,
  payload: {
    blockTemplates,
  },
});

export default setBlockTemplates;
